<template>
	<div>
		<article class="iv2-article">
			<Error403 v-if="contact.open_type == 0" />

			<div v-else-if="contact.open_type == 1">
				<LayoutTitle :contact="contact" />
				<div v-if="contact.form_type == 'gen'">
					<LayoutFormBasic :contact="contact" :is_agreement="agreement" />
				</div>
				<div v-else-if="contact.form_type == 'biz'">
					<LayoutFormBusiness :contact="contact" :is_agreement="agreement" />
				</div>
				<div v-else-if="contact.form_type == 'cus'">
					<LayoutFormCustomer :contact="contact" :is_agreement="agreement" />
				</div>
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutFormBasic from "./components/LayoutFormBasic.vue";
import LayoutFormBusiness from "./components/LayoutFormBusiness.vue";
import LayoutFormCustomer from "./components/LayoutFormCustomer.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Error403 from "@/components/systems/Page403.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutFormBasic,
		LayoutFormBusiness,
		LayoutFormCustomer,
		BaseLoading,
		Error403,
	},
	data() {
		return {
			contact: [],
			agreement: "",
			loading: true,
		};
	},

	mounted() {
		if(this.$route.query.mode == 'preview') {
			this.axios.get("/preview/contacts", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			})
			.then((response) => {
				this.contact = response.data;
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		}else{
			this.axios.get("/contacts").then((response) => {
				this.contact = response.data;
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		}
	},
};
</script>

<style lang="scss">
</style>
